export default __webpack_public_path__ + "static/media/GAN5.bc8a36cc.png";